import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

import { useThemeSwitch } from '@/shared/lib/theme';
import { Button, MoonIcon, SunIcon } from '@/shared/ui';

/** Light ⇄ dark, labelled by where it goes rather than where it is. */
export function ThemeToggle(): JSX.Element {
  const { t } = useTranslation('common');
  const { theme, toggle } = useThemeSwitch();
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <Button
      aria-label={t(`theme.${next}`)}
      className="tap-target !px-0"
      onClick={toggle}
      size="sm"
      variant="ghost"
    >
      {theme === 'dark' ? <SunIcon className="size-5" /> : <MoonIcon className="size-5" />}
    </Button>
  );
}
